const STATUS_LABEL = {
  open: 'Open',
  claimed: 'In progress',
  resolved: 'Resolved',
  closed: 'Closed',
};

export default function TicketList({ tickets, onOpen, onNew }) {
  return (
    <div className="p-4 space-y-3">
      <button className="btn-primary w-full" onClick={onNew}>
        New conversation
      </button>

      {tickets.length === 0 && (
        <p className="text-sm text-gray-500 text-center py-8">No conversations yet.</p>
      )}

      {tickets.map((ticket) => (
        <button
          key={ticket.id}
          onClick={() => onOpen(ticket.id)}
          className="card w-full text-left hover:shadow-md transition"
        >
          <div className="flex items-center justify-between mb-1">
            <span className="text-xs font-medium text-grey-700">{ticket.products?.name}</span>
            <span className="text-xs text-gray-500">{STATUS_LABEL[ticket.status]}</span>
          </div>
          <p className="text-sm text-gray-900 truncate">{ticket.subject}</p>
        </button>
      ))}
    </div>
  );
}
